import Wrapper from '../wrapper'
import P from '../../../ui/Placeholder'

const Placeholder = () => (
  <Wrapper>
    <P style={{ height: 16 }} />
    <P style={{ height: 40 }} />
    <P style={{ height: 16 }} />
    <P style={{ height: 16 }} />
  </Wrapper>
)

export default Placeholder
